module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-radio-group', {
    staticStyle: {
      "display": "flex",
      "margin-top": "10px"
    },
    attrs: {
      "disabled": !_vm.disabled
    },
    on: {
      "change": _vm.changeType
    },
    model: {
      value: (_vm.curSelectVal),
      callback: function($$v) {
        _vm.curSelectVal = $$v
      },
      expression: "curSelectVal"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("部分学生")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("特权角色")])], 1), _vm._v(" "), (_vm.curSelectVal === 1) ? _c('div', {
    staticClass: "margin-top-10"
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "请输入学生id",
      "disabled": !_vm.disabled
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.state),
      callback: function($$v) {
        _vm.state = $$v
      },
      expression: "state"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.disabled
    },
    on: {
      "click": _vm.handlePush
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('div', {
    staticClass: "user-content"
  }, _vm._l((_vm.selectItemList), function(item) {
    return _c('el-tag', {
      key: item.uid,
      attrs: {
        "type": "primary",
        "closable": _vm.disabled
      },
      on: {
        "close": function($event) {
          return _vm.tagClose(item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_vm._v("共" + _vm._s(_vm.selectItemList.length) + "位")])])], 1) : _vm._e(), _vm._v(" "), (_vm.curSelectVal === 2) ? _c('div', {
    staticClass: "margin-top-10"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择特权角色",
      "multiple": "",
      "disabled": !_vm.disabled
    },
    model: {
      value: (_vm.selectPrivileges),
      callback: function($$v) {
        _vm.selectPrivileges = $$v
      },
      expression: "selectPrivileges"
    }
  }, _vm._l((_vm.privilegeOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-442f7146!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/UserAdminister/PersonalizedPart/Components/SelectStudent.vue
// module id = 1006
// module chunks = 0